


    <template>
            <div class="aside-2 ad">
                    <div class="bd">
                        <ul>
                            <li class="aside-2 ad" v-for="(item,index) in newsList" style="display: list-item;">
                                <a :href="item.items[0].url" target="_blank" alt="..."><img v-lazy="{
                                    loading: lazyLoading,
                                    error: lazyLoading,
                                    src: item.items[0]['images'][0]['url']
                                  }" ></a>
                            </li>
                        </ul>
                    </div>
                </div>
        </template>
        <script>
        import Vue from 'vue';
        import VueLazyload from 'vue-lazyload';
        Vue.use(VueLazyload);
            export default {
                props: [ 'list', 'clientId'],
                data() {
                    return {
                        newsList: []
                    };
                },
                computed: {
                    lazyLoading() {
                        if (this.clientId) {
                            return `/public/w/img/${this.clientId}/loading_news.png`;
                        } else {
                            return '/public/w/default/loading_news.png';
                        }
                    }
                },
                components: {},
                mounted(){
                  
                  if (this.clientId == 410900) {
                    this.newsList = this.list.reverse()
                  }else{
                    this.newsList = this.list
                  }
                }
            };
        </script>



// WEBPACK FOOTER //
// app/web/component/web/news-aside/ad-aside.vue